export enum LeadFiltersStatus {
All,
Pending,
Won,
Lost,
}
